<template>
  <v-container>
    <h1>New Company</h1>
    <v-form @submit.prevent="createCompany">
      <v-text-field
        v-model="name"
        label="Company Name"
        required
      ></v-text-field>
      <v-btn type="submit" color="primary" :loading="loading">Create Company</v-btn>
    </v-form>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'NewCompany',
  data() {
    return {
      name: '',
      loading: false
    }
  },
  methods: {
    async createCompany() {
      this.loading = true

      try {
        // Create data object

        await this.$http.post(`/api/company`, { name: this.name })
        
        this.$router.push('/company/list')
      } catch (error) {
        console.error('Error creating company:', error)
        alert(`Failed to create company: ${error.response.data.detail}`)
      }
      this.loading = false
    }
  }
}
</script>